import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationNL from './locales/nl/translation.json';
import translationEN from './locales/en/translation.json';
import translationPL from './locales/pl/translation.json';
import translationHU from './locales/hu/translation.json';

const resources = {
  nl: {
    translation: translationNL
  },
  en: {
    translation: translationEN
  },
  pl: {
    translation: translationPL
  },
  hu: {
    translation: translationHU
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl',
    debug: false,

    interpolation: {
      escapeValue: false // React already escapes
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;

